import { isInWindow, BaseClient, type InitializeProps } from '@snapchat/metrics-utils';
import { ActivityDetector } from './ActivityDetector';

// By default if user don't have any activity in 60 second, then it is inactive
export const defaultInactiveThreshold = 60;

export class Graphene extends BaseClient {
  activityDetector?: ActivityDetector;

  // Initialize graphene instance
  initialize(props: InitializeProps): void {
    if (this.isInitialized) {
      throw new Error("this instance has been initialized. Can't re-initialize it.");
    }
    super.initialize(props);

    const { inactiveThresholdInSecond = defaultInactiveThreshold } = props;

    if (isInWindow()) {
      this.activityDetector = new ActivityDetector(inactiveThresholdInSecond);
      // Trying to flush all events before leaving the page
      // Note that this is not guaranteed to completed before browser cancels the request
      // because blocking users from leaving current page is not a proper design
      window.addEventListener('beforeunload', this.flush);
    }
  }

  // send heart beat event
  sendHeartBeatCounter = (version: string): void => {
    if (!this.isInitialized) {
      return;
    }
    const heartBeatDuration = 60000;
    const sendHeartBeatEvent = () => {
      const active = this.activityDetector?.getIsActive() ? 'active' : 'inactive';
      this.increment({ metricsName: 'heart_beat', dimensions: { version, active } });
    };
    sendHeartBeatEvent();
    this.heartBeatId = setInterval(sendHeartBeatEvent, heartBeatDuration);
  };

  // Cancel the interval timer and reset metrics
  destroy(): void {
    super.destroy();
    if (isInWindow()) {
      window.removeEventListener('beforeunload', this.flush);
    }
    if (this.activityDetector) {
      this.activityDetector.destroy();
    }
  }
}

/** Default Graphene instance. If you need more clients, create them using `new Graphene()`. */
export const graphene = new Graphene();
